import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Settings from './components/Settings';
import AddonPage from './components/AddonPage';
import { userApi } from './api'; // Assure-toi que le chemin est correct

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [currentUser, setCurrentUser] = useState(null);
  const [currentView, setCurrentView] = useState(window.location.hash.replace('#', '') || 'dashboard'); // 'dashboard' | 'settings'

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '') || 'dashboard';
      setCurrentView(hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!isAuthenticated) return;

      try {
        const response = await userApi.getMe(); 
        setCurrentUser(response.data);
      } catch (error) {
        console.error("Erreur lors de la récupération du profil:", error);
        if (error.response && error.response.status === 401) {
          handleLogout();
        }
      }
    };

    fetchUserProfile();
  }, [isAuthenticated]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setCurrentUser(null);
    window.location.hash = ''; // Réinitialiser le hash à la déconnexion
  };

  const handleNavigate = (view) => {
    window.location.hash = view;
  };

  return (
    <div className="App min-h-screen bg-gray-900 text-white">
      {!isAuthenticated ? (
        <Login onLoginSuccess={() => setIsAuthenticated(true)} />
      ) : (
        <>
          <Navbar 
              user={currentUser}
              onNavigate={handleNavigate}
              onLogout={handleLogout} 
          />
          {/* On utilise un div avec hidden pour ne pas démonter le Dashboard (évite de recharger les images et requêtes API) */}
          <div className={currentView === 'dashboard' ? 'block' : 'hidden'}>
            <Dashboard />
          </div>
          {currentView === 'settings' && (
            <Settings user={currentUser} onUserUpdate={setCurrentUser} />
          )}
          {currentView === 'addon' && (
            <AddonPage />
          )}
        </>
      )}
    </div>
  );
}

export default App;